<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Mail Taslağı Düzenle</h4>
              <p class="card-category">Aşağıdaki form ile bir mail taslağı düzenleyin.</p>
            </template>

            <div v-if="isLoading === true">
              <h3 class="text-center">Yükleniyor...</h3>
            </div>
            <form v-if="isLoading === false" class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Kod Ismi" placeholder="Daha sonra aradığınızda kolay bulmanız için..."
                    v-model="mailTemplate.title">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Mail Başlığı" placeholder="Mail kutusuna bu başlık ile düşecektir."
                    v-model="mailTemplate.header">
                  </base-input>
                </div>
              </div>

              <div class="clearfix"></div>

              <div class="row">
                <div class="text-center">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="updateMailTemplate">
                    Kaydet
                  </button>
                </div>
              </div>







              <div class="clearfix"></div>
            </form>


          </card>
          <div class="alert alert-primary" v-if="mailTemplate.isHtml === true">
            Katalog maili düzenlenemez. Elinizdeki makinaları sistem üzerinden güncelledikten sonra yeni bir mail taslağı
            oluşturabilirsiniz..
          </div>

          <div class="container border">
            <h4>Mail Taslağı Önizleme</h4>
            <div class="email-preview">
              <div class="email-header">
                <h2>{{ mailTemplate.header }}</h2>
              </div>
              <div class="email-body" v-html="mailTemplatePreviewHtmlContent"></div>
              <div class="email-footer">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      isLoading: false,
      mailTemplate: {},
      mailTemplatePreviewHtmlContent: ''

    }
  },
  mounted() {
    this.id = window.location.href.split('/').at(-1);
    this.getMailTemplate();
  },
  methods: {
    updateMailTemplate() {
      CollectionService.updateCollectionItem('mailtemplate', this.id, this.mailTemplate).then((res) => {
        this.notifyVue('bottom', 'right', 'success', "Mail Taslağı Güncellendi")
        this.$router.push(`/admin/mailtemplates`);
      })
    },
    scrapeLagerMaschien() {
      CollectionService.getCollection('scrapeCatalog',).then((res) => {
        this.payload.catalog = res.data;
        this.notifyVue('bottom', 'right', 'success', 'Katalog çekildi, ' + this.payload.catalog.length)
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    deleteItem(item) {
      this.payload.catalog = this.payload.catalog.filter(x => x.id != item.id);
      this.notifyVue('bottom', 'right', 'warning', "Ürün taslaktan silindi.");
    },
    up(item) {
      var index = this.payload.catalog.findIndex(x => x.id == item.id);
      if (index == 0) return;

      var newCatalog = JSON.parse(JSON.stringify(this.payload.catalog));

      var temp = this.payload.catalog[index - 1];

      newCatalog[index - 1] = item;
      newCatalog[index] = temp;

      this.payload.catalog = newCatalog;
    },
    down(item) {
      var index = this.payload.catalog.findIndex(x => x.id == item.id);
      if (index == this.payload.catalog.length - 1) return;
      var newCatalog = JSON.parse(JSON.stringify(this.payload.catalog));


      var temp = this.payload.catalog[index + 1];

      newCatalog[index + 1] = item;
      newCatalog[index] = temp;

      this.payload.catalog = newCatalog;
    },
    getMailTemplate() {
      this.isLoading = true;
      CollectionService.getCollectionItemWithId('mailtemplate', this.id).then((res) => {
        if (res.success == true) {
          this.mailTemplate = res.mailTemplate;
          this.mailTemplatePreviewHtmlContent = res.htmlContent;
          this.isLoading = false;
        } else {
          console.log('error');
        }
      })
    },
  }
}
</script>
<style>
img {
  width: 200px;
  height: 200 px;
}
</style>